// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as QueryString from 'query-string';
import * as runtime from '../runtime';
import { objectToHash } from "common/object-helper";
/**
 * Export pmis to excel
 * Export pmis to excel
 */
export function exportPmisRaw(requestParameters, requestConfig = {}) {
    if (requestParameters.exportPmi === null || requestParameters.exportPmi === undefined) {
        throw new runtime.RequiredError('exportPmi', 'Required parameter requestParameters.exportPmi was null or undefined when calling exportPmis.');
    }
    let queryParameters = null;
    let queryString = "";
    queryParameters = {};
    if (requestParameters.exportPmi) {
        queryParameters['exportPmi'] = requestParameters.exportPmi;
    }
    queryString = `?${QueryString.stringify(queryParameters)}`;
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/pmis/export` + queryString,
        meta,
        update: requestConfig.update,
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform
    };
    config.queryKey = requestConfig.queryKey || `ExportPmis-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Export pmis to excel
* Export pmis to excel
*/
export function exportPmis(requestParameters, requestConfig) {
    return exportPmisRaw(requestParameters, requestConfig);
}
